import { render, staticRenderFns } from "./ContentEditable.vue?vue&type=template&id=4b2af37b&"
import script from "./ContentEditable.vue?vue&type=script&lang=js&"
export * from "./ContentEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports